import React from 'react';
import FileIconDisplay from '@/components/FileIconDisplay';

type DocumentCardProps = {
  title: string;
  description: string;
  filename?: string;
  onDownload?: () => void;
  onRemove?: () => void;
  showCounterBadge?: boolean;
  hasCounterOffer?: boolean;
  isInvestor?: boolean;
  isInEscrow?: boolean;
};

export const DocumentCard: React.FC<DocumentCardProps> = ({
  title,
  description,
  filename,
  onDownload,
  onRemove,
  showCounterBadge,
  hasCounterOffer,
  isInvestor,
  isInEscrow,
}) => {
  const isImage = filename?.match(/\.(jpg|jpeg|png|bmp|webp|svg)$/i) != null;
  const getFileInfo = () => {
    if (isInEscrow) {
      return 'Document should be provided during escrow';
    }

    if (isInvestor) {
      return 'Document not uploaded';
    }

    return 'No document uplaoded';
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-3">
      {/* Title with badge */}
      <div className="flex items-center gap-2">
        <div
          className="text-black text-base font-medium break-words"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          {title}
        </div>
        {showCounterBadge && (
          <>
            <div className="w-2 h-2 bg-[#BB8D03] rounded-full" />
            <span
              className="text-[#BB8D03] text-sm font-medium"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              Investor requested
            </span>
          </>
        )}
      </div>

      {/* Description */}
      <div
        className="text-[#767676] text-sm font-normal break-words"
        style={{
          fontFamily: 'var(--ep-font-avenir)',
        }}
      >
        {description}
      </div>

      {/* File card or upload area */}
      {filename ? (
        <div
          className={`w-full p-4 bg-[#F9F9F9] rounded-xl border ${
            hasCounterOffer ? 'border-[#BB8D03] border-2' : 'border-solid border-gray-200'
          } flex justify-between items-center`}
          onClick={onDownload}
        >
          <div className="flex justify-start items-center gap-3 min-w-0 flex-1">
            <div className="w-10 h-10  rounded-lg flex justify-center items-center flex-shrink-0">
              <FileIconDisplay isImage={isImage} />
            </div>
            <div
              className="text-black text-sm font-medium break-words min-w-0 overflow-hidden text-ellipsis sm:break-all sm:whitespace-normal whitespace-nowrap"
              style={{
                fontFamily: 'var(--ep-font-avenir)',
              }}
            >
              {filename}
            </div>
          </div>
          <div className="flex items-center gap-2">
            {onRemove && (
              <button
                onClick={onRemove}
                className="w-8 h-8 bg-[#F4F4F4] rounded-lg flex justify-center items-center cursor-pointer border-none"
              >
                <span className="text-[#767676] text-lg">×</span>
              </button>
            )}
          </div>
        </div>
      ) : (
        <div
          className={`w-full p-6 bg-[#F9F9F9] rounded-xl border-2 border-dashed ${
            hasCounterOffer ? 'border-[#BB8D03]' : 'border-gray-200'
          } flex flex-col justify-center items-center gap-2 cursor-pointer`}
        >
          <div
            className="text-[#767676] text-sm font-medium"
            style={{
              fontFamily: 'var(--ep-font-avenir)',
            }}
          >
            {getFileInfo()}
          </div>
        </div>
      )}
    </div>
  );
};
